import { forwardRef } from 'react';
import clsx from 'clsx';

import type { BoxProps } from '../../Box/Box';
import { Box } from '../../Box/Box';
import { Text } from '../../Text/Text';

import { header, headerWithHoverBorder, noPadding as styles_noPadding } from './styles.css';

export type Props = {
  children?: React.ReactNode;
  noPadding?: boolean;
  showHoverBorder?: boolean;
} & BoxProps;

export const Header = forwardRef<HTMLDivElement, Props>(
  ({ children, noPadding, showHoverBorder = true, cssClass, ...boxProps }, ref) => (
    <Box
      cssClass={clsx(
        header,
        {
          [styles_noPadding]: noPadding,
          [headerWithHoverBorder]: showHoverBorder,
        },
        cssClass,
      )}
      ref={ref}
      {...boxProps}
    >
      <Text size="xSmall">{children}</Text>
    </Box>
  ),
);
